module.exports = __webpack_public_path__ + "images/questions/qa_bg_box_ffe89839cd7575aa7f6e7b9cf4354af0.png";